"use strict";
import { LitElement, html } from "lit";
export class MicrositeHtmlBuilder extends LitElement {
  render() {
    return html`
      <div class="eab-html-builder-root" part="root">
        <slot></slot>
      </div>
    `;
  }
}
customElements.define("stc-html-builder", MicrositeHtmlBuilder);
